import { Palette, Trophy, Brain, Dices, Leaf, Music, MessageCircle, CloudMoon } from "lucide-react";

export const PODRUCJA = [
  { value: "Kreativno-likovne", icon: Palette, badge: "bg-pink-100 text-pink-700" },
  { value: "Sportsko-rekreativne", icon: Trophy, badge: "bg-emerald-100 text-emerald-700" },
  { value: "Edukativne igre", icon: Brain, badge: "bg-blue-100 text-blue-700" },
  { value: "Društvene igre", icon: Dices, badge: "bg-amber-100 text-amber-700" },
  { value: "Priroda i okoliš", icon: Leaf, badge: "bg-green-100 text-green-700" },
  { value: "Glazbeno-plesne", icon: Music, badge: "bg-violet-100 text-violet-700" },
  { value: "Jezično-komunikacijske", icon: MessageCircle, badge: "bg-sky-100 text-sky-700" },
  { value: "Smirivanje i opuštanje", icon: CloudMoon, badge: "bg-teal-100 text-teal-700" },
];

export const badgeZaPodrucje = (p) =>
  PODRUCJA.find((x) => x.value === p)?.badge || "bg-slate-100 text-slate-700";

export const ikonaZaPodrucje = (p) => PODRUCJA.find((x) => x.value === p)?.icon || Dices;

export const RAZREDI = [1, 2, 3, 4];

export const MJESTA = ["Učionica", "Dvorište", "Sportska dvorana"];

export const BUKA = ["Tiho", "Umjereno", "Glasno"];

export const GRUPE = [
  { value: "Mala", label: "Mala (do 10)" },
  { value: "Srednja", label: "Srednja (10–20)" },
  { value: "Velika", label: "Velika (20+)" },
];

export const SEZONE = [
  "Cijela godina", "Jesen", "Zima", "Proljeće", "Ljeto",
  "Božić", "Uskrs", "Maškare", "Valentinovo", "Majčin dan", "Dan planeta Zemlje",
  "Dani kruha", "Dan jabuka", "Dan kravate", "Sveti Nikola", "Dan zagrljaja", "Dan škole",
];

export const DANI = [
  { id: "pon", label: "Ponedjeljak", kratko: "Pon" },
  { id: "uto", label: "Utorak", kratko: "Uto" },
  { id: "sri", label: "Srijeda", kratko: "Sri" },
  { id: "cet", label: "Četvrtak", kratko: "Čet" },
  { id: "pet", label: "Petak", kratko: "Pet" },
];

export const TRAJANJA = [
  { id: "do15", label: "do 15 min", test: (t) => t <= 15 },
  { id: "15-30", label: "15–30 min", test: (t) => t > 15 && t <= 30 },
  { id: "30-45", label: "30–45 min", test: (t) => t > 30 && t <= 45 },
  { id: "45plus", label: "više od 45 min", test: (t) => t > 45 },
];

export const CILJ_MINUTA = 120;
